import AuthModel from './AuthModel'

class Permissions {

    static getUserRole() {
        const user = AuthModel.getLoggedUser();
        return user ? user.roles_id : '';
    }

    static isDenied(schema, action, record = false) {
        var allowed = true, r = true
        const user = AuthModel.getLoggedUser()
        user.permissions.forEach((access) => {
            if ((schema === access.a) && (action === access.b)) {
                allowed = access.c
                if (record) {
                    access.p.forEach((policy) => {
                        r = Permissions[policy.n](record, policy)
                        allowed = allowed && r
                    })
                }
            }
        })
        return !allowed
    }

    static perm_is_not_canceled(record, policy) {
        return record.status !== policy.p1
    }

    static perm_is_not_submitted(record, policy) {
        return record.status !== policy.p2
    }

    static perm_is_owner(record) {
        const user = AuthModel.getLoggedUser()
        return user.id === record.owner_id
    }

    static perm_is_in_same_role(record) {
        const user = AuthModel.getLoggedUser()
        return user.roles_id === record.roles_id
    }

    static perm_is_in_same_entity(record) {
        const user = AuthModel.getLoggedUser()
        return user.entidade_id === record.entidade_id
    }
}

export default Permissions



// WEBPACK FOOTER //
// ./src/models/Permissions.js